import React, { createElement } from "react";

import { TagsProps } from "./tags.model";
import { useTags } from "./hooks/useTags";
import { Tag } from "./Tag";

import "@companion-core/web/src/Assets/Styles/scss/tags.scss";

export const Tags = ({
  tags,
  limit = 3,
  clickable = true,
  className,
  type = "primary",
}: TagsProps) => {
  const {
    limitedTags,
    remainingTagsCount,
    remainingTags,
    showRemainingTags,
    setShowRemainingTags,
  } = useTags(tags, limit);

  const expendTagComponent = createElement(
    clickable ? "button" : "span",
    {
      "data-testid": "tags__expand",
      ...(clickable && { type: "button" }),
      className: `tags__tag body-text-8${clickable ? " tags__tag--button" : ""} tags__tag--${type}`,
      onClick: clickable ? () => setShowRemainingTags(true) : undefined,
    },
    `+${remainingTagsCount}`
  );

  return (
    <div className={`tags${className ? ` ${className}` : ""}`}>
      {limitedTags.map((tag) => (
        <Tag key={tag} tag={tag} />
      ))}
      {remainingTagsCount > 0 && !showRemainingTags && expendTagComponent}
      {showRemainingTags && (
        <>
          {remainingTags.map((tag) => (
            <Tag key={tag} tag={tag} />
          ))}
        </>
      )}
    </div>
  );
};
